import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'
import Login from '../Login.vue'
import Main from '../Main.vue'
import leftMenu from '../LeftMenu.vue'
import qrCodeList from '../web/qrCode/List.vue'
import qrCodePublishList from '../web/qrCode/PublishList.vue'

// import qrCodeInList from '../web/qrCode/inList.vue'
import qrCodeInDetailList from '../web/qrCode/inDetailList.vue'
import qrCodeOutList from '../web/qrCode/outList.vue'
import qrCodeOutDetailList from '../web/qrCode/outDetailList.vue'

import memberList from '../web/member/List.vue'

import newAccount from '../NewAccount.vue'
import mapList from '../web/map/List.vue'
import store from '../store';
import mobile from '../mobile.vue'
import mobile2 from '../mobile2.vue'
import mobile3 from '../mobile3.vue'
import mobile4 from '../mobile4.vue'
import mobile144 from '../mobile144.vue'


import rightMain from '../web/chart/RightMain.vue'

import dataGps from '../web/data/gps.vue'
import blockedIp from '../web/data/BlockedIp.vue'
import healthRestart from '../web/data/HealthRestart.vue'
import dataReport from '../web/data/Report.vue'

import dataReport2 from '../web/data/Report2.vue'
import dataReport3 from '../web/data/Report3.vue'
import dataReport4 from '../web/data/Report4.vue'


import manisDetailList from '../web/qrCode/manisDetailList.vue'


import classeumDetailList from '../web/qrCode/classeumDetailList.vue'
import classeumWayBill from '../web/qrCode/classeumWayBill.vue'


import option1DetailList from '../web/qrCode/option1DetailList.vue'
import option1WayBill from '../web/qrCode/option1WayBill.vue'


import lemonCustomer from "@/views/web/qrCode/lemonCustomer";

import lemonMapping from "@/views/web/qrCode/lemonMapping";

import le2Customer from "@/views/web/qrCode/le2Customer";

import le2Mapping from "@/views/web/qrCode/le2Mapping";



import MonthReportBarChart from '../components/MonthReportBarChart.vue'

import nextPlayMapping from "@/views/web/qrCode/nextPlayMapping";

import ktngDetailList from "@/views/web/qrCode/kt&gDetailList";
import ktngItemInfo from "@/views/web/qrCode/kt&gItemInfo";


import GlobientDetailList from "@/views/web/qrCode/GlobientDetailList";
import GlobientItemInfo from "@/views/web/qrCode/GlobientItemInfo";

import GlobientDetailList2 from "@/views/web/qrCode/GlobientDetailList2";
import GlobientDetailList3 from "@/views/web/qrCode/GlobientDetailList3";

import GlobientCustomerInfo from "@/views/web/qrCode/GlobientCustomerInfo";

import nextPlayBoxMapping from "@/views/web/qrCode/nextPlayBoxMapping";


import panartisDetailList from '../web/qrCode/panartisDetailList.vue'
import panartisWayBill from '../web/qrCode/panartisWayBill.vue'

import heliodDetailList from '../web/qrCode/heliodDetailList.vue'


import jmbiotechCustomer from "@/views/web/qrCode/jmbiotechCustomer";
import jmbiotechMapping from "@/views/web/qrCode/jmbiotechMapping";



import koruCustomer from "@/views/web/qrCode/koruCustomer";

import koruMapping from "@/views/web/qrCode/koruMapping";

import aiAgent from '../web/ai/authInfoAgent.vue';


import fileUpload from '../web/file/fileUpload.vue';


Vue.use(VueRouter)


const requireAuth = (value) => (to, from, next) => {

  console.log("==========value ==="+value+"=============");
  console.log("=========accessToken===="+store.state.accessToken+"=============");

  return next();

  // this.$router.push({ name: 'Login' })
  //
  // return from
};



const routes = [


  {
    path: '/leftMenu',
    name: 'leftMenu',
    component: leftMenu,

    children: [

      { // 파일 리스트
        path: '/ai/authInfoAgent',
        name: 'aiAgent',
        component: aiAgent,
        beforeEnter: requireAuth('1')
      },


      { // 파일 리스트
        path: '/file/fileUpload',
        name: 'fileUpload',
        component: fileUpload,
        beforeEnter: requireAuth('1')
      },


      {
        path: '/Main',
        name: 'Main',
        component: Main,
        beforeEnter: requireAuth('1'),
      },

      {
        path: '/MonthReportBarChart',
        name: 'MonthReportBarChart',
        component: MonthReportBarChart,
        beforeEnter: requireAuth('1'),
      },


      {
        path: '/data/gps',
        name: 'dataGps',
        component: dataGps,
        beforeEnter: requireAuth('1'),
      },

      {
        path: '/data/blockedIp',
        name: 'blockedIp',
        component: blockedIp,
        beforeEnter: requireAuth('1'),
      },

      {
        path: '/data/healthRestart',
        name: 'healthRestart',
        component: healthRestart,
        beforeEnter: requireAuth('1'),
      },

      {
        path: '/data/report',
        name: 'dataReport',
        component: dataReport,
        beforeEnter: requireAuth('1'),
      },

      {
        path: '/data/report2',
        name: 'dataReport2',
        component: dataReport2,
        beforeEnter: requireAuth('1'),
      },

      {
        path: '/data/report3',
        name: 'dataReport3',
        component: dataReport3,
        beforeEnter: requireAuth('1'),
      },


      {
        path: '/data/report4',
        name: 'dataReport4',
        component: dataReport4,
        beforeEnter: requireAuth('1'),
      },



      // {
      //   path: '/qrCode/inList',
      //   name: 'qrCodeInList',
      //   component: qrCodeInList,
      //   beforeEnter: requireAuth('1'),
      // },


      {
        path: '/member/List',
        name: 'memberList',
        component: memberList,
        beforeEnter: requireAuth('1'),
      },

      {
        path: '/qrCode/inDetailList',
        name: 'qrCodeInDetailList',
        component: qrCodeInDetailList,
        beforeEnter: requireAuth('1'),
      },

      {
        path: '/qrCode/manisDetailList',
        name: 'manisDetailList',
        component: manisDetailList,
        beforeEnter: requireAuth('1'),
      },

      {
        path: '/qrCode/classeumDetailList',
        name: 'classeumDetailList',
        component: classeumDetailList,
        beforeEnter: requireAuth('1'),
      },


      {
        path: '/qrCode/classeumWayBill',
        name: 'classeumWayBill',
        component: classeumWayBill,
        beforeEnter: requireAuth('1'),
      },


      {
        path: '/qrCode/option1DetailList',
        name: 'option1DetailList',
        component: option1DetailList,
        beforeEnter: requireAuth('1'),
      },


      {
        path: '/qrCode/option1WayBill',
        name: 'option1WayBill',
        component: option1WayBill,
        beforeEnter: requireAuth('1'),
      },


      {
        path: '/qrCode/lemonCustomer',
        name: 'lemonCustomer',
        component: lemonCustomer,
        beforeEnter: requireAuth('1'),
      },

      {
        path: '/qrCode/le2Customer',
        name: 'le2Customer',
        component: le2Customer,
        beforeEnter: requireAuth('1'),
      },

      {
        path: '/qrCode/lemonMapping',
        name: 'lemonMapping',
        component: lemonMapping,
        beforeEnter: requireAuth('1'),
      },

      {
        path: '/qrCode/koruCustomer',
        name: 'koruCustomer',
        component: koruCustomer,
        beforeEnter: requireAuth('1'),
      },


      {
        path: '/qrCode/koruMapping',
        name: 'koruMapping',
        component: koruMapping,
        beforeEnter: requireAuth('1'),
      },



      {
        path: '/qrCode/le2Mapping',
        name: 'le2Mapping',
        component: le2Mapping,
        beforeEnter: requireAuth('1'),
      },


      {
        path: '/qrCode/jmbiotechCustomer',
        name: 'jmbiotechCustomer',
        component: jmbiotechCustomer,
        beforeEnter: requireAuth('1'),
      },

      {
        path: '/qrCode/jmbiotechMapping',
        name: 'jmbiotechMapping',
        component: jmbiotechMapping,
        beforeEnter: requireAuth('1'),
      },


      {
        path: '/qrCode/outList',
        name: 'qrCodeOutList',
        component: qrCodeOutList,
        beforeEnter: requireAuth('1'),
      },

      {
        path: '/qrCode/outDetailList',
        name: 'qrCodeOutDetailList',
        component: qrCodeOutDetailList,
        beforeEnter: requireAuth('1'),
      },

      { // RFID 주문(생산처)
        path: '/chart/RightMain',
        name: 'rightMain',
        component: rightMain,
        beforeEnter: requireAuth('1'),
      },

      { // RFID 주문(생산처)
        path: '/qrCode/List',
        name: 'qrCodeList',
        component: qrCodeList,
        beforeEnter: requireAuth('1'),
      },

      { // 발행
        path: '/qrCode/PublishList',
        name: 'qrCodePublishList',
        component: qrCodePublishList,
        beforeEnter: requireAuth('1')
      },

      { // google mape
        path: '/map/List',
        name: 'mapList',
        component: mapList,
        beforeEnter: requireAuth('1')
      },


      {
        path: '/qrCode/nextPlayMapping',
        name: 'nextPlayMapping',
        component: nextPlayMapping,
        beforeEnter: requireAuth('1'),
      },

      {
        path: '/qrCode/nextPlayBoxMapping',
        name: 'nextPlayBoxMapping',
        component: nextPlayBoxMapping,
        beforeEnter: requireAuth('1'),
      },



      {
        path: '/qrCode/GlobientDetailList',
        name: 'GlobientDetailList',
        component: GlobientDetailList,
        beforeEnter: requireAuth('1'),
      },

      {
        path: '/qrCode/GlobientDetailList2',
        name: 'GlobientDetailList2',
        component: GlobientDetailList2,
        beforeEnter: requireAuth('1'),
      },

      {
        path: '/qrCode/GlobientDetailList3',
        name: 'GlobientDetailList3',
        component: GlobientDetailList3,
        beforeEnter: requireAuth('1'),
      },

      {
        path: '/qrCode/kt&gDetailList',
        name: 'ktngDetailList',
        component: ktngDetailList,
        beforeEnter: requireAuth('1'),
      },


      {
        path: '/qrCode/GlobientItemInfo',
        name: 'GlobientItemInfo',
        component: GlobientItemInfo,
        beforeEnter: requireAuth('1'),
      },


      // {
      //   path: '/qrCode/GlobientItemInfo2',
      //   name: 'GlobientItemInfo2',
      //   component: GlobientItemInfo2,
      //   beforeEnter: requireAuth('1'),
      // },


      {
        path: '/qrCode/GlobientCustomerInfo',
        name: 'GlobientCustomerInfo',
        component: GlobientCustomerInfo,
        beforeEnter: requireAuth('1'),
      },





      {
        path: '/qrCode/kt&gItemInfo',
        name: 'ktngItemInfo',
        component: ktngItemInfo,
        beforeEnter: requireAuth('1'),
      },

      {
        path: '/qrCode/panartisDetailList',
        name: 'panartisDetailList',
        component: panartisDetailList,
        beforeEnter: requireAuth('1'),
      },

      {
        path: '/qrCode/heliodDetailList',
        name: 'heliodDetailList',
        component: heliodDetailList,
        beforeEnter: requireAuth('1'),
      },




      {
        path: '/qrCode/panartisWayBill',
        name: 'panartisWayBill',
        component: panartisWayBill,
        beforeEnter: requireAuth('1'),
      },



      // {
      //   path: '*',notFound
      //   name: 'notFound',
      //   // 아래처럼 바로 NotFound 경로를 매칭해도 됨
      //   component: leftMenu
      // },


    ],
  },
  {
    path: '/Login',
    name: 'Login',
    component: Login
  },

  {
    path: '/',
    name: 'mobile',
    component: mobile
  },

  {
    path: '/mobile2',
    name: 'mobile2',
    component: mobile2
  },

  {
    path: '/mobile3',
    name: 'mobile3',
    component: mobile3
  },
  {
    path: '/mobile4',
    name: 'mobile4',
    component: mobile4
  },

  {
    path: '/mobile144',
    name: 'mobile144',
    component: mobile144
  },

  {
    path: '*',
    name: 'notFound',
    // 아래처럼 바로 NotFound 경로를 매칭해도 됨
     component: leftMenu
  },

  {
    path: '/newAccount',
    name: 'newAccount',
    component: newAccount
  },




]

const router = new VueRouter({
  mode: "history",
  // base: process.env.BASE_URL,
  routes
})


// const util = require('./util.js')
//
//
// router.get('/download',(req, res)=>{
//   util.download(req, res)
// })

export default router
